import { Component, OnInit, Output } from '@angular/core';
import { Orgstyle } from '../orgaccount/orgstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Meta } from '@angular/platform-browser';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-useraccount',
  templateUrl: './useraccount.component.html',
  styleUrls: ['./useraccount.component.css']
})
export class UseraccountComponent implements OnInit {
  @Output() orgstyle:Orgstyle;
  customerportal:boolean;
  personId:string;
  saveperson:number;


  constructor(private meta:Meta, private uieventhub:UieventhubService,
  ) { }

  ngOnInit() {
    //this.uieventhub.setShowLoader(true);
    this.saveperson = 0;
    this.meta.addTags([
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' },
    ]);   
    this.orgstyle = new Orgstyle;
    this.orgstyle.sidenav = 'top';
    this.personId = SessionHelper.getUserSub();
    if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined' ){
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    }
    this.customerportal = false;
    if(SessionHelper.getCustomer()){
      this.customerportal = true;
    }
    //this.uieventhub.setShowLoader(false);
  }
  savepersonclick(){
    this.saveperson++;

  }
 

}
